import pr from "./pr";

function GetApiHost ()
{
    let host = 'https://api.smartg.kr:3000';
    if(process.env.REACT_APP_ENV !== undefined) {
        if( process.env.REACT_APP_ENV.trim() === 'dev' ) {
            host = 'http://192.168.0.58:3000';
        }
        if( process.env.REACT_APP_ENV.trim() === 'staging' ) {
            host = 'http://192.168.76.23:3000';
        }
    }
    return host;
}

export default GetApiHost;